var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93231 6.00002L0.251156 2.31886C-0.0837187 1.98399 -0.0837187 1.44105 0.251156 1.10618C0.586031 0.7713 1.12897 0.7713 1.46384 1.10618L5.75134 5.39368C6.08622 5.72855 6.08622 6.27149 5.75134 6.60636L1.46384 10.8939C1.12897 11.2287 0.586031 11.2287 0.251156 10.8939C-0.0837187 10.559 -0.0837187 10.0161 0.251156 9.68118L3.93231 6.00002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.82728af6075d0bfae473e626c34c687b.svg";
export { ForwardRef as ReactComponent };